import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class ServicesParametrizationService extends Service {
  path = 'servico'

  async get(params: any) {
    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async download(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async put(id: string, payload: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}?servicoId=${id}`,
      payload
    )
    return httpResponse
  }

  async delete(id: string) {
    const httpResponse = await this.httpClient.delete(
      `${this.path}?servicoId=${id}`
    )
    return httpResponse
  }

  async post(payload: any) {
    const httpResponse = await this.httpClient.post(this.path, payload)
    return httpResponse
  }
}

export const servicesParametrizationService =
  new ServicesParametrizationService()
